import openfield from '../../assets/footer/openfield-logo-transparent-dark@2x.png';

const logoSagiton =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 32"><path d="M94.695,3.549V0H110l-2.341,3.549ZM78.777,13.911V31.719h-3.5V7.132h4.881l4,14.717V7.132h3.468V31.719h-4ZM66.889,32c-3.818,0-5.906-2.248-5.906-6.183V13.033c0-3.933,2.088-6.181,5.906-6.181S72.8,9.1,72.8,13.033V25.817C72.8,29.752,70.71,32,66.889,32Zm2.018-19.212c0-1.757-.78-2.423-2.018-2.423s-2.016.666-2.016,2.423V26.065c0,1.756.779,2.423,2.016,2.423s2.018-.667,2.018-2.423ZM55.535,31.719H51.644V10.645H47.577V7.132H59.6v3.513H55.535ZM41.986,7.132h3.892V31.719H41.986ZM33.674,32c-3.821,0-5.8-2.248-5.8-6.183V13.033c0-3.933,1.981-6.181,5.8-6.181s5.8,2.248,5.8,6.181v2.389H35.8V12.788c0-1.757-.778-2.423-2.016-2.423s-2.019.666-2.019,2.423V26.065c0,1.756.78,2.388,2.019,2.388s2.016-.632,2.016-2.388V21.533H34.028V18.021h5.447v7.8C39.475,29.752,37.495,32,33.674,32ZM21.827,27.259H17.049l-.671,4.46H12.805L16.767,7.132h5.695l3.962,24.587H22.5ZM19.419,11.488,17.545,23.922H21.3ZM5.8,32C1.981,32,0,29.752,0,25.817V24.308H3.679v1.757c0,1.756.779,2.388,2.016,2.388s2.016-.632,2.016-2.388c0-5.059-7.6-6.006-7.6-13.032,0-3.933,1.945-6.181,5.73-6.181s5.731,2.248,5.731,6.181v.773H7.889V12.788c0-1.757-.708-2.423-1.946-2.423S4,11.031,4,12.788c0,5.058,7.605,6,7.605,13.029C11.6,29.752,9.623,32,5.8,32ZM104.309,7.678,99.346,5.549H110L94.695,28.835V19.742h1.684Z"/></svg>';

const PoweredBy = ({ language }) => {
    return (
        <div className="landing-container-footer-poweredby">
            <div className="landing-poweredby">
                <span>Powered by</span>
                <a
                    href="https://openfield.pl/"
                    className="landing-logo-link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={openfield} className="logo-link" alt="" />
                </a>
              
                <a
                    href={`https://www.sagiton.pl/${language}/`}
                    className="landing-logo-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    dangerouslySetInnerHTML={{ __html: logoSagiton }}
                />
            </div>
        </div>
    )
}

export default PoweredBy;
